import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import ArticlePage from "../pages/article-what-is-oopbuy-spreadsheet/page";
import HowWorksPage from "../pages/article-how-oopbuy-spreadsheet-works/page";
import BeginnerGuidePage from "../pages/article-oopbuy-spreadsheet-beginner-guide/page";
import BestToolsPage from "../pages/article-best-oopbuy-spreadsheet-tools/page";
import TopComparedPage from "../pages/article-top-oopbuy-spreadsheets-compared/page";
import FreeVsPaidPage from "../pages/article-free-vs-paid-oopbuy-spreadsheet/page";
import DropshippingPage from "../pages/article-oopbuy-spreadsheet-dropshipping/page";
import EcommercePage from "../pages/article-oopbuy-spreadsheet-ecommerce/page";
import MakeMoneyPage from "../pages/article-make-money-oopbuy-spreadsheet/page";
import ProductResearchPage from "../pages/article-oopbuy-spreadsheet-product-research/page";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/article/what-is-oopbuy-spreadsheet",
    element: <ArticlePage />,
  },
  {
    path: "/article/how-oopbuy-spreadsheet-works",
    element: <HowWorksPage />,
  },
  {
    path: "/article/oopbuy-spreadsheet-beginner-guide",
    element: <BeginnerGuidePage />,
  },
  {
    path: "/article/best-oopbuy-spreadsheet-tools",
    element: <BestToolsPage />,
  },
  {
    path: "/article/top-oopbuy-spreadsheets-compared",
    element: <TopComparedPage />,
  },
  {
    path: "/article/free-vs-paid-oopbuy-spreadsheet",
    element: <FreeVsPaidPage />,
  },
  {
    path: "/article/oopbuy-spreadsheet-dropshipping",
    element: <DropshippingPage />,
  },
  {
    path: "/article/oopbuy-spreadsheet-ecommerce",
    element: <EcommercePage />,
  },
  {
    path: "/article/make-money-oopbuy-spreadsheet",
    element: <MakeMoneyPage />,
  },
  {
    path: "/article/oopbuy-spreadsheet-product-research",
    element: <ProductResearchPage />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;